// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-layout-page-js": () => import("./../src/layout/page.js" /* webpackChunkName: "component---src-layout-page-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-members-js": () => import("./../src/pages/members.js" /* webpackChunkName: "component---src-pages-members-js" */)
}

